'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallbackRef } from '#pplx/frontend/common/hooks/useCallbackRef.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useRef } from 'react';
// Only this wrapper is eager; the check, flag, and warning load lazily to keep Home's chunk flat.
const ComputerMissingAttachmentCheck = Dynamic(() => import('#pplx/frontend/apps/ask/computer/missing-attachment/ComputerMissingAttachmentCheck.js').then((module) => ({ default: module.ComputerMissingAttachmentCheck })), { loading: () => null });
/** Lets the lazily loaded check hold a Computer task's first message; otherwise it sends right away. */
export function useComputerMissingAttachmentGuard({ onSubmit, ...draft }) {
    const guardRef = useRef(null);
    const guardedSubmit = useCallbackRef((submission) => guardRef.current?.(() => onSubmit(submission)) ?? onSubmit(submission));
    const element = draft.isComputer && (_jsx(ComputerMissingAttachmentCheck, { ...draft, guardRef: guardRef }));
    return { onSubmit: guardedSubmit, element };
}
//# sourceMappingURL=useComputerMissingAttachmentGuard.js.map